import { Grid, Stack, Typography } from '@mui/material';
import { InboxBlock } from '@/components/home/inbox/InboxBlock';
import { LetterCountDTO } from '@/types/letter/LetterCountDTO';
import { Theme } from '@mui/material/styles';
import { useOutletContext } from 'react-router-dom';
import React, { FC, ReactElement } from 'react';

interface OutletProps {
  inboxCount?: LetterCountDTO;
}

export const MobileInboxBlock: FC = (): ReactElement => {
  const { inboxCount } = useOutletContext<OutletProps>();

  return (
    <Grid container={true} direction={'column'} spacing={2}>
      <Grid item={true}>
        <Stack direction={'row'} spacing={1}>
          <Typography variant={'h2'} fontSize={'20px'} lineHeight={'24px'} fontWeight={500}>
            {'Входящие'}
          </Typography>
          {!isNaN(Number(inboxCount?.totalCount)) && (
            <Typography
              variant={'h2'}
              fontSize={'20px'}
              lineHeight={'24px'}
              fontWeight={400}
              sx={{ color: (theme: Theme) => theme.colors.grayText }}>
              {inboxCount?.totalCount}
            </Typography>
          )}
        </Stack>
      </Grid>
      <Grid item={true}>
        <InboxBlock />
      </Grid>
    </Grid>
  );
};
